import {IonInput, IonLabel, IonSelect, IonSelectOption, IonTextarea} from "@ionic/react";
import styles from "./CustomField.module.scss";
import {Fragment} from "react";
import styles_Pg_C_1 from "../pages/Pg_C_1.module.scss";
import ClassNames from "../components/ClassNames";

type Props = {
    field: any
    errors?: any

    // children?: any
    noLabel?: boolean
    alternateLabel?: any
    className?: any
    innerClassName?: any
    inputClassName?: any
    alternateRightZone?: any
    alternateLeftZone?: any
    alternateRightZoneFunc?: any
    alternateLeftZoneFunc?: any
    mainZoneFunc?: any
    disabled?: boolean
    textType?: string
    showLabel?: boolean
};

const CustomField = ({
                         field,
                         errors,

                         // children = null,
                         noLabel = false,  //default no label
                         showLabel = false,
                         className = null,
                         innerClassName = null,
                         inputClassName = "",
                         alternateLabel = null,
                         alternateRightZone = null,
                         alternateLeftZone = null,
                         alternateRightZoneFunc = null,
                         alternateLeftZoneFunc = null,
                         mainZoneFunc = null,

                         disabled = false,
                         textType = 'text',
                     }: Props) => {
    if (!field) {
        return <>(ERROR:field)</>;
    }

    const error = errors && errors.filter(e => e.id === field.id)[0];
    const errorMessage = error && errors.filter(e => e.id === field.id)[0].message;

    if (field?.nodisplay === true) {
        return null;
    }

    let finalPlacedOutput: any = <Fragment>
        {textType === 'textarea' ? <>
            <IonTextarea className={`${styles.customInput} ${inputClassName}`} {...field.input.props} {...field.input.state} {...{'disabled': (disabled ? 'disabled' : null)}} />
        </> : <>
            <IonInput className={`${styles.customInput} ${inputClassName}`} {...field.input.props} {...field.input.state} {...{'disabled': (disabled ? 'disabled' : null)}} />
        </>}
    </Fragment>;

    let mainZoneRendered: any = null;
    if (mainZoneFunc !== null) {
        mainZoneRendered = <Fragment>
            {mainZoneFunc && mainZoneFunc(field.input.state?.reset)}
        </Fragment>;
    } else {
        mainZoneRendered = <Fragment>
            {textType === 'textarea' ? <>
                <IonTextarea className={`${styles.customInput} ${inputClassName}`} {...field.input.props} {...field.input.state} disabled={(disabled ? 'disabled' : null)}/>
                {alternateRightZone}
                {alternateRightZoneFunc && alternateRightZoneFunc(field.input.state?.reset)}
            </> : <>
                <IonInput className={`${styles.customInput} ${inputClassName}`} {...field.input.props} {...field.input.state} disabled={(disabled ? 'disabled' : null)}/>
                {alternateRightZone}
                {alternateRightZoneFunc && alternateRightZoneFunc(field.input.state?.reset)}
            </>}
        </Fragment>
    }
    if (alternateLeftZone !== null || alternateRightZone !== null) {
        finalPlacedOutput = <Fragment>
            <div className={styles.rowsContainer}>
                {alternateLeftZone}
                {alternateLeftZoneFunc && alternateLeftZoneFunc(field.input.state?.reset)}
                {mainZoneRendered}
            </div>
        </Fragment>;
    } else {
        finalPlacedOutput = <Fragment>
            {mainZoneRendered}
        </Fragment>;
    }

    return (
        <>
            <div className={className}>
                <div className={ClassNames(styles.field, innerClassName)}>
                    {showLabel && !alternateLabel &&
                        <div>
                            <IonLabel>
                                {field.label}:
                            </IonLabel>
                        </div>
                    }
                    {!noLabel && error && (
                        <IonLabel>
                            <span>&nbsp;</span>
                            {<p className="animate__animated animate__bounceIn">{errorMessage}</p>}
                        </IonLabel>
                    )}
                    {finalPlacedOutput}
                </div>
            </div>
        </>
    );
};

export default CustomField;
